<template>
  <div style="display: flex; justify-content: space-around">
    <el-checkbox
      v-model="job.electric"
      :disabled="disabled"
      style="margin: 0"
      @change="onChange('electric')"
    >{{ $t("CargoMsg.Electric") }}
    </el-checkbox>
    <el-checkbox
      v-model="job.magnetic"
      :disabled="disabled"
      style="margin: 0; padding-left: 5px"
      @change="onChange('magnetic')"
    >{{ $t("CargoMsg.Magnetic") }}
    </el-checkbox>
    <el-checkbox
      v-model="job.powder"
      :disabled="disabled"
      style="margin: 0; padding-left: 5px"
      @change="onChange('powder')"
    >{{ $t("CargoMsg.Powder") }}
    </el-checkbox>
    <el-checkbox
      v-model="job.liquid"
      :disabled="disabled"
      style="padding-left: 5px"
      @change="onChange('liquid')"
    >{{ $t("CargoMsg.Liquid") }}
    </el-checkbox>
  </div>
</template>

<script>
export default {
  name: 'SeCharacteristic',
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
